'use strict';

function parse(rawValue) {
  var parsed = parseValue(rawValue);
  if (parsed === undefined) {
    return null;
  }
  return parsed;
}
function parseValue(rawValue) {
  try {
    return JSON.parse(rawValue);
  } catch (err) {
    return rawValue;
  }
}
module.exports = parse;